import BaseSvgIcon, { IconProps } from '@trustoo/components/ui/icon/BaseSvgIcon'

/**
 * Expand more icon (chevron down) component.
 * Reusable SVG icon for expand/collapse functionality.
 * If color is not provided, uses currentColor to inherit text color.
 */
const ExpandMoreIcon = (props: IconProps) => {
    return (
        <BaseSvgIcon {...props}>
            <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z" />
        </BaseSvgIcon>
    )
}

export default ExpandMoreIcon
